import { useEffect, useState } from "react";

type TemplateFilterIslandProps = {
  targetSelector?: string;
};

export function TemplateFilterIsland(props: TemplateFilterIslandProps) {
  const [activeCategory, setActiveCategory] = useState("全部");
  const [categories, setCategories] = useState(["全部"]);

  useEffect(() => {
    const selector = props.targetSelector || "[data-template-list]";
    const container = document.querySelector<HTMLElement>(selector);
    if (!container) {
      return;
    }

    const nextCategories = new Set<string>(["全部"]);
    const cards = container.querySelectorAll<HTMLElement>("[data-template-category]");
    for (const card of cards) {
      const category = card.dataset.templateCategory || "";
      if (category) {
        nextCategories.add(category);
      }
      const visible = activeCategory === "全部" || category === activeCategory;
      card.style.display = visible ? "" : "none";
    }
    setCategories(Array.from(nextCategories));
  }, [activeCategory, props.targetSelector]);

  return (
    <div className="flex flex-wrap gap-2 rounded-[22px] border border-brand-100 bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(238,242,255,0.92))] p-4 shadow-panel">
      {categories.map((category) => (
        <button
          key={category}
          className={
            category === activeCategory
              ? "inline-flex min-h-10 items-center justify-center rounded-full bg-brand-600 px-5 text-[14px] font-medium text-white shadow-[0_12px_24px_rgba(79,70,229,0.22)] transition-transform hover:-translate-y-0.5"
              : "inline-flex min-h-10 items-center justify-center rounded-full border border-slate-200 bg-white px-5 text-[14px] font-medium text-slate-700 transition-transform hover:-translate-y-0.5"
          }
          type="button"
          onClick={() => {
            setActiveCategory(category);
          }}
        >
          {category}
        </button>
      ))}
    </div>
  );
}
